import { ReactNode } from 'react'
import { Box, Container } from '@mui/material'
import Header from './Header'
import SubHeader from './SubHeader'
import PageHeader from './PageHeader'
import Footer from './Footer'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <SubHeader />
      <PageHeader />
      <Box component="main" sx={{ flexGrow: 1, bgcolor: '#f7f7f7', pt: 0, pb: 4 }}>
        <Container maxWidth="lg">
          {children}
        </Container>
      </Box>
      <Footer />
    </Box>
  )
}

export default Layout